import { type ReactNode, useCallback, useEffect, useState } from 'react';

import {
  type InsuranceType,
  InsuranceTypeContext,
} from './InsuranceTypeContext';

const STORAGE_KEY = 'assurelis_insurance_type';

interface InsuranceTypeProviderProps {
  children: ReactNode;
}

export default function InsuranceTypeProvider({
  children,
}: InsuranceTypeProviderProps) {
  const [selectedType, setSelectedTypeState] = useState<InsuranceType>(() => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored === 'auto' || stored === 'life' || stored === 'disability') {
      return stored;
    }
    return null;
  });

  useEffect(() => {
    if (selectedType) {
      sessionStorage.setItem(STORAGE_KEY, selectedType);
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }, [selectedType]);

  const setSelectedType = useCallback((type: InsuranceType) => {
    setSelectedTypeState(type);
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedTypeState(null);
    sessionStorage.removeItem(STORAGE_KEY);
  }, []);

  const value = {
    selectedType,
    setSelectedType,
    clearSelection,
  };

  return (
    <InsuranceTypeContext.Provider value={value}>
      {children}
    </InsuranceTypeContext.Provider>
  );
}
